import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { groupTitle } from '../../../shared/styles/groupTitle.vanilla.mjs';
import { useSingleSelectGroupContext } from '../../contexts/group-context.mjs';

const SingleSelectGroupTitle = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const { id } = useSingleSelectGroupContext("GroupTitle");
  const className = classNames(groupTitle, classNameFromProps);
  return /* @__PURE__ */ jsx(
    Primitive.span,
    {
      id,
      "data-scope": "single-select",
      "data-part": "group-title",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectGroupTitle as SelectGroupTitle };
//# sourceMappingURL=GroupTitle.mjs.map
